import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import Container from '../../../Core/Container';
import Link from '../../../Core/Link';
import RichText, { fragment } from '../../../Core/RichText';
import IndividualBlade from '../../IndividualBlades';
import AppStores from '../../AppStores';

import {
  Wrapper,
  Content,
  Features,
  IconCollection,
  VideoWrapper,
  FeaturedVideos,
  Links,
  Product,
  Img,
} from './styles';

const header = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <p className="large">{children}</p>,
    [BLOCKS.HEADING_2]: (_, children) => <h2 className="large">{children}</h2>,
    [BLOCKS.HEADING_3]: (_, children) => <h3 className="large">{children}</h3>,
  },
};

const DigitalProductBlock = ({ className = '', data }) => {
  if (!data) return null;
  const {
    imageDam,
    heading,
    bodyCopy,
    features,
    badges,
    videos,
    ctas,
    component,
  } = data;

  return (
    <Container backgroundColor="light-grey" className={className || component}>
      <Wrapper className={`${className || component}`}>
        {(heading || bodyCopy) && (
          <Content>
            {heading && <RichText document={heading} options={header} />}
            {bodyCopy && <RichText document={bodyCopy} />}
          </Content>
        )}
        <Features>
          <>
            {features && (
              <IconCollection data={features} className="app-banner" />
            )}
            {badges && <AppStores badges={badges} />}
            {videos && (
              <VideoWrapper>
                {videos
                  .map(
                    ({
                      id,
                      updatedAt,
                      pageSlug,
                      sections: videoTutorialSections,
                      videoTutorialProductCategories,
                      videoTutorialCategories,
                      frenchVideoTutorialProductCategories,
                      frenchVideoTutorialCategories,
                    }) => {
                      const video = videoTutorialSections.find(
                        ({ __typename }) =>
                          __typename === 'ContentfulVideoItem',
                      );
                      if (!video) return null;
                      return (
                        <FeaturedVideos
                          key={id}
                          url={`/learning-hub/video-tutorials/${pageSlug}`}
                          title={video.videoLabel}
                          description={video.videoDescription}
                          thumbnail={video.thumbnailDam}
                          duration={video.videoDuration}
                          contentType={videoTutorialCategories}
                          productType={videoTutorialProductCategories}
                          contentTypeFR={frenchVideoTutorialCategories}
                          productTypeFR={frenchVideoTutorialProductCategories}
                          updatedAt={updatedAt}
                          className={component}
                        />
                      );
                    },
                  )
                  .filter(video => !!video)}
              </VideoWrapper>
            )}
            {ctas && (
              <Links>
                {ctas.map(cta => {
                  if (cta.hideFrench === true) return null;
                  return cta.internal.type === 'ContentfulBlade' ? (
                    <IndividualBlade key={cta.id} data={cta} />
                  ) : (
                    <Link key={cta.id} data={cta}>
                      <RichText document={cta.label} options={fragment} />
                    </Link>
                  );
                })}
              </Links>
            )}
          </>
          {imageDam && (
            <Product>
              <Img src={imageDam} alt="" />
            </Product>
          )}
        </Features>
      </Wrapper>
    </Container>
  );
};

DigitalProductBlock.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape().isRequired,
};

export default DigitalProductBlock;
